/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Счётчики по типам заявлений: trademarkApplications — заявления на создание товарного знака, далее — по одному счётчику на каждый тип заявления (renewal — продление товарного знака)
 * @export
 * @interface GetSidebarState200ResponseDataApplicationsApplicationsByType
 */
export interface GetSidebarState200ResponseDataApplicationsApplicationsByType {
  /**
   * Количество заявлений на создание товарного знака
   * @type {number}
   * @memberof GetSidebarState200ResponseDataApplicationsApplicationsByType
   */
  trademarkApplications: number
  /**
   * Количество заявлений на продление товарного знака
   * @type {number}
   * @memberof GetSidebarState200ResponseDataApplicationsApplicationsByType
   */
  renewal: number
}

/**
 * Check if a given object implements the GetSidebarState200ResponseDataApplicationsApplicationsByType interface.
 */
export function instanceOfGetSidebarState200ResponseDataApplicationsApplicationsByType(
  value: object
): value is GetSidebarState200ResponseDataApplicationsApplicationsByType {
  if (
    !('trademarkApplications' in value) ||
    value['trademarkApplications'] === undefined
  )
    return false
  if (!('renewal' in value) || value['renewal'] === undefined) return false
  return true
}

export function GetSidebarState200ResponseDataApplicationsApplicationsByTypeFromJSON(
  json: any
): GetSidebarState200ResponseDataApplicationsApplicationsByType {
  return GetSidebarState200ResponseDataApplicationsApplicationsByTypeFromJSONTyped(
    json,
    false
  )
}

export function GetSidebarState200ResponseDataApplicationsApplicationsByTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetSidebarState200ResponseDataApplicationsApplicationsByType {
  if (json == null) {
    return json
  }
  return {
    trademarkApplications: json['trademarkApplications'],
    renewal: json['renewal'],
  }
}

export function GetSidebarState200ResponseDataApplicationsApplicationsByTypeToJSON(
  value?: GetSidebarState200ResponseDataApplicationsApplicationsByType | null
): any {
  if (value == null) {
    return value
  }
  return {
    trademarkApplications: value['trademarkApplications'],
    renewal: value['renewal'],
  }
}
